import ReactMarkdown, { type Components } from "react-markdown";

// Zentrales Styling für alle Markdown-Bodies in der Timeline.
// Body-Headings starten bei ## (h2), weil h1 = Session-Titel der Karte.
const components: Components = {
  h2: (props) => (
    <h2
      className="mt-8 mb-2 text-base font-semibold tracking-tight text-fg first:mt-0"
      {...props}
    />
  ),
  h3: (props) => (
    <h3
      className="mt-5 mb-2 text-sm font-semibold tracking-tight text-fg"
      {...props}
    />
  ),
  p: (props) => (
    <p className="my-3 leading-relaxed text-fg-muted" {...props} />
  ),
  ul: (props) => (
    <ul className="my-3 space-y-1.5 pl-5 text-fg-muted [list-style:disc]" {...props} />
  ),
  ol: (props) => (
    <ol className="my-3 space-y-1.5 pl-5 text-fg-muted [list-style:decimal]" {...props} />
  ),
  li: (props) => <li className="leading-relaxed" {...props} />,
  a: (props) => (
    <a
      className="text-accent underline underline-offset-2 hover:opacity-80"
      target="_blank"
      rel="noreferrer"
      {...props}
    />
  ),
  code: (props) => (
    <code
      className="rounded bg-bg-elevated px-1.5 py-0.5 font-mono text-[0.85em] text-fg"
      {...props}
    />
  ),
  blockquote: (props) => (
    <blockquote
      className="my-4 border-l-2 border-border pl-4 italic text-fg-muted"
      {...props}
    />
  ),
  strong: (props) => <strong className="font-semibold text-fg" {...props} />,
  em: (props) => <em className="italic" {...props} />,
  hr: () => <hr className="my-6 border-t border-border" />,
};

export function MarkdownRenderer({ children }: { children: string }) {
  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
}
